import React from 'react';

import size from 'lodash/size';
import { Field } from 'formik';
import indexOf from 'lodash/indexOf';
import isEqual from 'lodash/isEqual';
import { connect } from 'react-redux';

import SelectField from '../../components/SelectField';
import MoneyTextField from '../../components/MoneyTextField';
import DatePickerField from '../../components/DatePickerField';

import validate from './validations';

import { PAGES } from '../../config/constants';
import { MARGIN_TOP } from '../../config/constants';
import pms_use_funds from '../../constants/pms_use_funds';
import pms_no_of_units from '../../constants/pms_no_of_units';
import pms_property_type from '../../constants/pms_property_type';
import pms_exit_strategy from '../../constants/pms_exit_strategy';
import pms_exit_repay_loan from '../../constants/pms_exit_repay_loan';
import pms_purpose_of_loan from '../../constants/pms_purpose_of_loan';
import pms_transaction_type from '../../constants/pms_transaction_type';
import pms_suburban_or_rural from '../../constants/pms_suburban_or_rural';
import pms_occupancy_at_closing from '../../constants/pms_occupancy_at_closing';
import pms_intended_occupancy_status_cc from '../../constants/pms_intended_occupancy_status_cc';
import { RESIDENTIAL, COMMERCIAL, TDS, LAND } from '../../constants/typeOfHomeOptions';

class EnchancedForm1 extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    const { setValuesChanged, values } = this.props;

    if (isEqual(values, prevProps.values) === false) {
      setValuesChanged(values);
    }
  }

  render() {
    const { handleSubmit, type_of_loan, setPrevPage } = this.props;

    const checkSubmit = (_values, _handleSubmit) => {
      const errors = validate(_values);

      if (size(errors) === 0) {
        _handleSubmit();
      }
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <Field
              name="purpose_of_loan"
              component={SelectField}
              label="Purpose of Loan *"
              options={pms_purpose_of_loan}
              required
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="property_type"
              component={SelectField}
              label="Property Type *"
              options={pms_property_type}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="no_of_units"
              component={SelectField}
              label="# of Units *"
              options={pms_no_of_units}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="transaction_type"
              component={SelectField}
              label="Transaction Type *"
              options={pms_transaction_type}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="use_of_funds"
              component={SelectField}
              label="Use of Funds *"
              options={pms_use_funds}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="occupancy"
              component={SelectField}
              label="Occupancy Status *"
              options={pms_intended_occupancy_status_cc}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />
          </div>
          <div className="col-md-6">
            <Field
              name="occupancy_at_closing"
              component={SelectField}
              label="Occupancy at COE *"
              options={pms_occupancy_at_closing}
              required
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="suburban_or_rural"
              component={SelectField}
              label="Suburban / Rural *"
              options={pms_suburban_or_rural}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="coe_date"
              component={DatePickerField}
              label="Preferred Close Date (PCD) *"
              required
              formControlStyle={{
                style: {
                  marginTop: MARGIN_TOP,
                  marginBottom: 0,
                  width: '100%',
                },
              }}
            />

            <Field
              name="exit_strategy"
              component={SelectField}
              label="Exit Strategy *"
              options={pms_exit_strategy}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            <Field
              name="exit_repay_loan"
              component={SelectField}
              label="How do you plan to exit Loan *"
              options={pms_exit_repay_loan}
              required
              formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
              cstmOnChange={async vals => {
                await Promise.resolve();

                checkSubmit(vals, handleSubmit);
              }}
            />

            {indexOf([RESIDENTIAL.value, COMMERCIAL.value, TDS.value, LAND.value], type_of_loan) !==
              -1 && (
              <Field
                name="property_income"
                component={MoneyTextField}
                label="Rental Income"
                required
                formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
                cstmOnChange={async vals => {
                  await Promise.resolve();

                  checkSubmit(vals, handleSubmit);
                }}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div style={{ marginTop: MARGIN_TOP, width: '100%' }}>
              <div style={{ float: 'left' }}>
                <button type="button" className="cstm_btn cstm_btn-text" onClick={setPrevPage}>
                  Back
                </button>
              </div>
              <div style={{ float: 'right' }}>
                <button type="button" className="cstm_btn cstm_btn-blue" onClick={handleSubmit}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  return {
    consoleBrok1: state.consoleBrok1,
    type_of_loan: state.form.accounts.type_of_loan,
    id_status: state.form.contacts.id_status,
  };
};

const mapDispatch = dispatch => {
  return {
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.PROPERTY_ADDRESS,
      });
    },

    setValuesChanged: values => {
      dispatch({
        type: 'SET_CONSOLE_BROK1',
        payload: values,
      });
    },

    setValues: values => {
      dispatch({
        type: 'SET_CONSOLE_BROK1',
        payload: values,
      });

      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.CONSOLE_BROOK_2,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(EnchancedForm1);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/EnhancedForm1.js